export const API_CONFIG = {
  // Camera API endpoints (local backend)
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/v2',
  // Login API endpoint - use same base as API
  LOGIN_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/v2',
  ENDPOINTS: {
    LOGIN: '/login',
    LOGOUT: '/logout',
    LOCATIONS: '/camera-security/camera-locations',
    LOCATION: '/camera-security/camera-location',
    CAMERAS: '/camera-security/cameras',
    CAMERA: '/camera-security/camera',
    CAMERA_STREAM: '/camera-security/camera/stream',
    CAMERA_SECURITY: '/camera-security', // Base path for edge sync endpoints
    EVENTS: '/camera-security/events',
    EVENT: '/camera-security/event',
    ACTIONS: '/camera-security/actions',
    ACTION: '/camera-security/action',
    VISITOR_LOGS: '/camera-security/visitor-logs',
    VISITOR_LOG: '/camera-security/visitor-log',
    VISITOR_LOG_UPLOAD_IMAGE: '/camera-security/visitor-log/upload-image',
    // Parking endpoints
    PARKING_LOTS: '/camera-security/parking/lots',
    PARKING_SPOTS: '/camera-security/parking/spots',
    // Tenant endpoints
    TENANTS: '/common/tenants',
    TENANT: '/common/tenant',
    COMPANY: '/common/company',
    REGISTER: '/common/register',
    // Dropdown endpoints
    DROPDOWN: '/common/dropdown',
    PUBLIC_DROPDOWN: '/common/public-dropdown',
    SUB_BUSINESS_TYPES: '/common/sub-business-types',
    COUNTRIES: '/common/countries',
    STATES: '/common/states',
    CITIES: '/common/cities',
    // Impersonation endpoints
    IMPERSONATE: '/common/impersonate',
    IMPERSONATE_EXIT: '/common/impersonate/exit',
    IMPERSONATE_STATUS: '/common/impersonate/status',
    // Location Actions endpoints
    LOCATION_ACTIONS: '/camera-security/locations', // + /{location_id}/actions
    LOCATION_ACTION: '/camera-security/actions', // + /{action_id}
    // Person Registry endpoints
    PERSONS: '/camera-security/persons',
    PERSON_DETAIL: '/camera-security/persons', // + /{id}/detail
    PERSON_FACES: '/camera-security/persons', // + /{id}/faces
    PERSON_LOCATIONS: '/camera-security/persons', // + /{id}/locations
    PERSON_VEHICLES: '/camera-security/persons', // + /{id}/vehicles
    PERSON_LOOKUP_PLATE: '/camera-security/persons/lookup/by-plate',
  },
};

export const getAuthToken = (): string | null => localStorage.getItem('authToken');
export const setAuthToken = (token: string): void => localStorage.setItem('authToken', token);
export const removeAuthToken = (): void => localStorage.removeItem('authToken');
export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};
